import { CONFIG_URL } from '@/utils/constants'

const UNITS = () => `${CONFIG_URL}/units`

export default {
  UNITS,
}
